import { CareTeamMemberCardProps } from '~/lib/types/careTeam/careTeam';
import { useDeleteProviderTeamAssignmentMutation } from '~/store/services/treatmentEpisodes';

export const useVoidCareTeamMembers = () => {
  const [
    deleteProviderTeamAssignment,
    { isLoading: isDeleteProviderTeamAssignmentLoading },
  ] = useDeleteProviderTeamAssignmentMutation();

  const voidMembersFromCareTeam = async (
    treatmentEpisodeId: string,
    membersToVoid: CareTeamMemberCardProps[],
    patientId: string,
    inquiryId?: string,
    skipCacheInvalidation?: boolean,
  ) => {
    await Promise.all(
      (membersToVoid || []).map((member) =>
        deleteProviderTeamAssignment({
          assignmentId: member.assignmentId,
          treatmentEpisodeId,
          voidReasonCode: member.voidReason,
          patientId,
          inquiryId,
          skipCacheInvalidation,
        }).unwrap(),
      ),
    );
  };

  return {
    isLoading: isDeleteProviderTeamAssignmentLoading,
    voidMembersFromCareTeam,
  };
};
